import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";
import { userLogout } from "store/slices/AuthenticationSlice";
import { connect } from "react-redux";
import * as routePath from "shared/constants/RoutePathConstants";

export function Logout(props: any) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(userLogout());
  });

  if (!props.isLoggedIn) {
    return <Redirect to={routePath.SIGN_IN} />;
  }

  return <>Logging out..</>;
}

const mapStateToProps = (state: any) => {
  return {
    isLoggedIn: state.authData.isAuthenticated,
  };
};

export default connect(mapStateToProps)(Logout);
